import Vue from 'vue'
import * as qconstants from "@/vendor/qconstants";
import {ebus} from "@/vendor/ebus";

export default {
  state: {},
  actions: {},
  mutations: {},
  getters: {
    selfServiceEnabled: (state, getters, rootState, rootGetters) => {
      return !!rootGetters.appconfig.selfServiceEnabled;
    },
    orderingEnabled: (state, getters, rootState, rootGetters) => {
      return !!rootGetters.appconfig.orderingEnabled;
    },
    takeawayOrderingEnabled: (state, getters, rootState, rootGetters) => {
      return rootGetters.appconfig.orderingEnabled && rootGetters.appconfig.takeawayOrderingEnabled;
    },
    inhouseOrderingEnabled: (state, getters, rootState, rootGetters) => {
      return rootGetters.appconfig.orderingEnabled && rootGetters.appconfig.inhouseOrderingEnabled;
    },
    deliveryOrderingEnabled: (state, getters, rootState, rootGetters) => {
      return rootGetters.appconfig.orderingEnabled && rootGetters.appconfig.deliveryOrderingEnabled;
    },

    enableKioskInhouseOhnePay: (state, getters, rootState, rootGetters) => {
      return rootGetters.appconfig.orderingEnabled && qconstants.enableKioskInhouseOhnePay;
    },
    enableKioskInhouseMitPay: (state, getters, rootState, rootGetters) => {
      return rootGetters.appconfig.orderingEnabled && qconstants.enableKioskInhouseMitPay;
    },
    enableKioskTakeAwayOhnePay: (state, getters, rootState, rootGetters) => {
      return rootGetters.appconfig.orderingEnabled && qconstants.enableKioskTakeAwayOhnePay;
    },
    enableKioskTakeAwayMitPay: (state, getters, rootState, rootGetters) => {
      return rootGetters.appconfig.orderingEnabled && qconstants.enableKioskTakeAwayMitPay;
    },

    enableInhouseOhnePay: (state, getters, rootState, rootGetters) => {
      if (rootGetters.isKiosk) {
        return rootGetters.appconfig.orderingEnabled && qconstants.enableKioskInhouseOhnePay;
      } else {
        return rootGetters.appconfig.orderingEnabled && rootGetters.appconfig.inhouseOrderingEnabled && qconstants.enableInhouseOhnePay;
      }
    },
    enableInhousePay: (state, getters, rootState, rootGetters) => {
      if (rootGetters.isKiosk) {
        return rootGetters.appconfig.orderingEnabled && qconstants.enableKioskInhouseMitPay;
      } else {
        return rootGetters.appconfig.orderingEnabled && rootGetters.appconfig.inhouseOrderingEnabled && qconstants.enableInhousePay;
      }
    },
    enableTakeawayPay: (state, getters, rootState, rootGetters) => {
      if (rootGetters.isKiosk) {
        return rootGetters.appconfig.orderingEnabled && qconstants.enableKioskTakeAwayMitPay;
      } else {
        return rootGetters.appconfig.orderingEnabled && rootGetters.appconfig.takeawayOrderingEnabled && qconstants.enableTakeawayPay;
      }
    },
    enableTakeawayOhnePay: (state, getters, rootState, rootGetters) => {
      if (rootGetters.isKiosk) {
        return rootGetters.appconfig.orderingEnabled && qconstants.enableKioskTakeAwayOhnePay;
      } else {
        return rootGetters.appconfig.orderingEnabled && rootGetters.appconfig.takeawayOrderingEnabled && qconstants.enableTakeawayOhnePay;
      }
    },
    enableDeliveryOhnePay: (state, getters, rootState, rootGetters) => {
      if (rootGetters.isKiosk) {
        return false;
      } else {
        return rootGetters.appconfig.orderingEnabled && rootGetters.appconfig.deliveryOrderingEnabled && qconstants.enableDeliveryOhnePay;
      }
    },
    enableDeliveryPay: (state, getters, rootState, rootGetters) => {
      if (rootGetters.isKiosk) {
        return false;
      } else {
        return rootGetters.appconfig.orderingEnabled && rootGetters.appconfig.deliveryOrderingEnabled && qconstants.enableDeliveryPay;
      }
    },
  }
};
